import {UI} from "../../../../stem-core/src/ui/UIBase";

import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../Messages";
import {MerchantButton} from "../../../common/MerchantButton";
import {PoweredByBlink} from "../../PoweredByBlink";
import {Link} from "../../../../stem-core/src/ui/UIPrimitives";
import {ThankYouPanelStyle} from "../thank-you/ThankYouPanel";
import {DonationStore} from "../../../../client/state/DonationStore";
import {DONATE_PAGE_URLS} from "../../PanelConstants";
import {Flow} from "../../initializeFlows";
import {styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";
import {MessageElement} from "../../../widget/ui/MessageElement";


export class CancelDonationPanelStyle extends ThankYouPanelStyle {
    @styleRuleInherit
    button = {
        marginTop: 0,
        marginBottom: 10,
    }
}

@registerStyle(CancelDonationPanelStyle)
export class CancelDonationPanel extends UI.Element {
    render() {
        const {styleSheet} = this;
        const publicationName = iFrameMerchantService.getMerchant().name;

        return [
            <div className={styleSheet.title}>{Messages.donatePageCancelDonationTitle}</div>,
            <MessageElement className={styleSheet.text}
                            message={Messages.donatePageCancelDonationText1(publicationName)}/>,
            <div className={styleSheet.text}>{Messages.donatePageCancelDonationText2(publicationName)}</div>,
            <MerchantButton onClick={() => Flow.donation.donatePageCancel(this.options.changeURL)} className={styleSheet.button}>
                {Messages.donatePageCancelDonationButton}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.takeMeBack} className={styleSheet.link}
                      onClick={() => this.options.changeURL(DONATE_PAGE_URLS.editDonation)} />
            </div>,
            <PoweredByBlink />,
        ];
    }

    onMount() {
        super.onMount();
        this.attachChangeListener(DonationStore, () => {
            if (this.isInDocument() && !iFrameUserDataService.getActiveRecurringDonation()) {
                    this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            }
        })
    }
}
